import React from 'react';
import CrewInboxPart2 from './CrewInbox-part2';

/**
 * CrewInbox.js
 * 
 * Thin wrapper component that imports the full implementation from CrewInbox-part2.js.
 * This keeps the file size small and maintains the same export name for routing.
 */
const CrewInbox = (props) => {
  return <CrewInboxPart2 {...props} />;
};

export default CrewInbox;
